<template>
  <div class="drag-form-container l-tabs-container">
    <el-form
      :label-position="formInfo.labelPosition || 'left'"
      :label-width="formInfo.labelWidth ? `${formInfo.labelWidth}px` : '80px'"
      :size="formInfo.size || 'mini'"
      :model="form"
    >
      <div @click="clickBlank" style="height: 100%;">
        <input type="text" style="display: none" />
        <drag-form-wraper
          ref="dragFormWraper"
          @tapassembly="tapassembly"
          :select.sync="selectWidget"
          :componentsList="formComponents"
        />
      </div>
    </el-form>
  </div>
</template>
<script>
import DragFormWraper from "./dragFormWraper";
export default {
  name: "drag-form",
  inject: ["formDesign"],
  components:{
    DragFormWraper
  },
  props: {
    select: Object,
    myTabsIndex: Number
  },
  // watch: {
  //   '$refs.dragFormWraper._data.selectWidget': {
  //     handler(newVal, oldVal) {
  //       console.log('userInfo 发生了变化');
  //     },
  //     deep: true // 开启深度监听
  //   }
  // },
  computed: {
    formInfo() {
      return this.formDesign.formInfo;
    },
    formComponents() {
      return (
        this.formDesign.formInfo.tabList[this.myTabsIndex].components || []
      );
    },
    selectWidget: {
      get() {
        return this.select;
      },
      set(val) {
        this.$emit("update:select", val);
      },
    },
    dbTables() {
      return this.formDesign.dbTables;
    },
  },
  data() {
    return {
      form: {},
    };
  },

  methods: {
    tapassembly(){
      this.$emit('tapCom',true)
    },
    clickBlank(){
    //   console.log('点击了空白');
      this.$emit('tapCom',false)
    },
    handleFormClickAdd(item) {
      this.$refs.dragFormWraper.handleFormClickAdd(item)
    }
  },
};
</script>
